/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiFrontendInternalLinkingNeighborhoodRetrieve200 } from './model/apiFrontendInternalLinkingNeighborhoodRetrieve200';

export const apiFrontendInternalLinkingNeighborhoodRetrieve = (
  countryCode: string,
  regionSlug: string,
  citySlug: string,
  neighborhoodSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<ApiFrontendInternalLinkingNeighborhoodRetrieve200>({
    url: `/api/v7/frontend/internal-linking/${countryCode}/${regionSlug}/${citySlug}/${neighborhoodSlug}/`,
    method: 'GET',
    signal,
  });
};

export const getApiFrontendInternalLinkingNeighborhoodRetrieveQueryKey = (
  countryCode?: string,
  regionSlug?: string,
  citySlug?: string,
  neighborhoodSlug?: string
) => {
  return [
    `/api/v7/frontend/internal-linking/${countryCode}/${regionSlug}/${citySlug}/${neighborhoodSlug}/`,
  ] as const;
};

export const getApiFrontendInternalLinkingNeighborhoodRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryCode: string,
  regionSlug: string,
  citySlug: string,
  neighborhoodSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendInternalLinkingNeighborhoodRetrieveQueryKey(
      countryCode,
      regionSlug,
      citySlug,
      neighborhoodSlug
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>
  > = ({ signal }) =>
    apiFrontendInternalLinkingNeighborhoodRetrieve(
      countryCode,
      regionSlug,
      citySlug,
      neighborhoodSlug,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(countryCode && regionSlug && citySlug && neighborhoodSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiFrontendInternalLinkingNeighborhoodRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>
>;
export type ApiFrontendInternalLinkingNeighborhoodRetrieveQueryError = ErrorType<unknown>;

export function useApiFrontendInternalLinkingNeighborhoodRetrieve<
  TData = Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryCode: string,
  regionSlug: string,
  citySlug: string,
  neighborhoodSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendInternalLinkingNeighborhoodRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiFrontendInternalLinkingNeighborhoodRetrieveQueryOptions(
    countryCode,
    regionSlug,
    citySlug,
    neighborhoodSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
